export default __webpack_public_path__ + "_/images/matches/man-mobile-791773e6cf5a9248a4b34375cdd3789fdc399e4cf654c5b6e2b33403016a4a15.png";